<template>
  <div>
    <div class="content_box row-column acea-row row-center-wrapper">
      <div
        :style="`backgroundImage: url(` + topHeaderImg + `)`"
        class="header_box row-column acea-row row-center-wrapper"
      >
        <div class="item">解决方案</div>
        <div class="item_small">-TOTAL SOLUTION-</div>
      </div>
      <div class="gary_text">{{ groupName }}</div>
      <div class="programmeEdit_content row-column acea-row row-center-wrapper">
        <ul class="info_ul  row-column acea-row row-center-wrapper" >
          <li class="info_li"> 无法真正保障安全:只有控制、功率限定、电流、电压、温度监测功能，缺乏短路、过欠压、过载、过温、打火、漏电等。</li>
          <li class="info_li"> 能源浪费严重:工业园区本身用能体量大，各种设备的用能浪费严重，如无人灯，待机功耗，开窗开空调，设备配置不合理，设备老化维护不到位等问题。大多数高校和医院并没有建立能效考核指标，用能群体对能源的使用的节约意识薄弱。</li>
          <li class="info_li"> 用电复杂，成本高:学校，医院，小区一体，占地面积大、建筑类型多、功能划分复杂，用能类型多样，运维人工管理成本高。</li>
          <li class="info_li"> 没有预警，人工排查:运维管理工作采用人力巡查为主的方式，人员的专业技能、专业工具参差不齐，对潜在的安全隐患不能第一时间发现，大多数都是故障、事故发生后才处理,不可避免会造成人员、财产损失。</li>
          <li class="info_li"> 设置复杂，数据粗糙︰用电管理系统平台不够灵活，数据不准确，各线辂用电数据不够明细或无法采集，设置上比较复杂，电工和宿舍管理员弃而不用。</li>
          <li class="info_li_img"> 
            <img class="img" src="@/assets/programme/kwh_content_bg1.png" alt="">
          </li>
        </ul>
      </div>
      <div class="gary_text">智慧用电管理终端</div>
      <div class="programmeEdit_content row-column acea-row row-center-wrapper">
        <ul class="info_ul  row-column acea-row row-center-wrapper" >
          <li class="info_li"> 高集成度的智慧终端，及后面支撑的云平台，可以直接网上进行多级多场景监视或监控，除电工外，用电单位各级负责人、集团和政府消防部门可即时、随时了解用电安全情况</li>
           <li class="info_li">用电管理效率高，无死角，精细，平台可以直接监视每台设备的各种用电数据，漏电、过载、过欠压、用能能耗等等;后端用电设备如有故障，及时通过APP微信及时推送，真正让您时时刻刻把用电情况掌握在手中。超过阈值或者规定的时间内没有执行开关电，进行告警并可远程执行开关。</li>
                     <li class="info_li"> 可根据需要随时灵活调整用电规划，收放自如，一改以前古板的用电管理方式，改造增添设备容易。</li>
                      <li class="info_li">方案简单，设备集成度高，施工和维护难度小，根据预算、重点对象和场景，选择不同的管理终端。</li>
          <li class="info_li_img"> 
            <img class="img_two" src="@/assets/programme/kwh_content_bg2.png" alt="">
          </li>
           <li class="info_li_img"> 
            <img class="img_two" src="@/assets/programme/kwh_content_bg3.png" alt="">
          </li>
          <li class="info_li_img">
            <applicationScene :dataList="dataList"></applicationScene>
          </li>
        </ul>
      </div>
      
    </div>
  </div>
</template>
<script>
import applicationScene from"@/components/programme/applicationScene"
export default {
  name: "qualifications",
  data() {
    return {
      topHeaderImg: require("@/assets/programme/programmebg1.png"),
      groupName: "现存各种配电方案的缺陷", //产品类型名称
      dataList: [
        {
          img: require("@/assets/programme/kwh_item_image1.png"),
        },
         {
          img: require("@/assets/programme/kwh_item_image2.png"),
        }, {
          img: require("@/assets/programme/kwh_item_image3.png"),
        },
         {
          img: require("@/assets/programme/kwh_item_image4.png"),
        },
         {
          img: require("@/assets/programme/kwh_item_image5.png"),
        },
         {
          img: require("@/assets/programme/kwh_item_image6.png"),
        }
      ]
    };
  },
  watch: {},
  components: {
    applicationScene:applicationScene
  },
  mounted: function () {},
};
</script>
<style scoped>
.content_box {
  width: 100%;
  background-color: #f3f3f3;
}
.content_box .info_ul .info_li{
  margin-bottom: 60px;
  color: #333333;
  font-size: 20px;
  width: 60%;
}
.content_box .info_ul .info_li_img{
  margin-bottom: 60px;
  color: #333333;
  font-size: 20px;
  width: 60%;
  list-style: none;
}
.content_box .info_ul .info_li_img .img{
  width: 100%;
  height: 100%;
  margin: 30px 0px;
}
.content_box .info_ul .info_li_img .img_two{
  width: 100%;
  height: 100%;
  margin: 30px 0px;
}
.content_box .header_box {
  width: 100%;
  height: 360px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content_box .header_box .item {
  color: #fff;
  font-size: 40px;
}
.content_box .header_box .item_small {
  color: #fff;
  font-size: 23px;
}
.content_box .programmeEdit_content {
  padding: 20px 0px;
}
/* 关于我们 begin */
.gary_text {
  font-size: 24px;
  color: #555555;
  margin: 40px 0px;
  margin-right: auto;
  padding-left: 21%;
}
/* 关于我们 end */
.profile_content {
  color: #333333;
  font-size: 20px;
  width: 65%;
  line-height: 45px;
  margin-bottom: 40px;
}
@media screen and (max-width: 850px) {
  .content_box .info_ul .info_li{
    width: 95%;
  }
  .content_box .info_ul .info_li_img{
    width: 95%;
  }
  .gary_text {
     padding-left: 10%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/programme/kwh.vue